import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import TextField from '@mui/material/TextField'
import Grid from '@mui/material/Grid'

const FormInput = ({ name, label }) => {
  const { control } = useFormContext()
//   const isError = false

  return (
    <Grid item xs={12} sm={6}>
      <Controller
        defaultValue=""
        control={control}
        name={name}
        // error={isError}
        render={({ field }) => (
          <TextField
            {...field}
            name={name}
            label={label}
            required
            fullWidth
          />
        )}
      />
    </Grid>
  )
}

export default FormInput